export const FETCH_LOCATION = "FETCH_LOCATION";
export const FETCH_LOCATION_SUCCEEDED = "FETCH_LOCATION_SUCCEEDED";
export const FETCH_LOCATION_FAILED = "FETCH_LOCATION_FAILED";
export const POPUP_SHOW_HIDE = "POPUP_SHOW_HIDE";
export const STORE_TOKEN = "STORE_TOKEN";
export const MOBILE_SEARCH_SHOW = "MOBILE_SEARCH_SHOW";
export const MOBILE_SEARCH_DATA = "MOBILE_SEARCH_DATA";
export const SET_ACTIVE_JOB_NAME = "SET_ACTIVE_JOB_NAME";

// User Profile
export const FETCH_USER_PROFILE_REQUEST = "FETCH_USER_PROFILE_REQUEST";
export const FETCH_USER_PROFILE_SUCCESS = "FETCH_USER_PROFILE_SUCCESS";
export const FETCH_USER_PROFILE_FAIL = "FETCH_USER_PROFILE_FAIL";

// Sign Out
export const SIGN_OUT = "SIGN_OUT";
export const SIGN_OUT_SUCCESS = "SIGN_OUT_SUCCESS";
export const SIGN_OUT_FAIL = "SIGN_OUT_FAIL";

// Popular Jobs
export const FETCH_POPULAR_JOBS_REQUEST = "FETCH_POPULAR_JOBS_REQUEST";
export const FETCH_POPULAR_JOBS_SUCCESS = "FETCH_POPULAR_JOBS_SUCCESS";
export const FETCH_POPULAR_JOBS_FAIL = "FETCH_POPULAR_JOBS_FAIL";

// Notifications
export const FETCH_NOTIFICATIONS_REQUEST = "FETCH_NOTIFICATIONS_REQUEST";
export const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS";
export const FETCH_NOTIFICATIONS_FAIL = "FETCH_NOTIFICATIONS_FAIL";

// Saved Jobs
export const FETCH_SAVED_JOBS_REQUEST = "FETCH_SAVED_JOBS_REQUEST";
export const FETCH_SAVED_JOBS_SUCCESS = "FETCH_SAVED_JOBS_SUCCESS";
export const FETCH_SAVED_JOBS_FAIL = "FETCH_SAVED_JOBS_FAIL";

export const FETCH_SAVED_JOBS_LIST_REQUEST = "FETCH_SAVED_JOBS_LIST_REQUEST";
export const FETCH_SAVED_JOBS_LIST_SUCCESS = "FETCH_SAVED_JOBS_LIST_SUCCESS";
export const FETCH_SAVED_JOBS_LIST_FAIL = "FETCH_SAVED_JOBS_LIST_FAIL";

// Save Job Actions
export const SAVE_JOB_REQUEST = "SAVE_JOB_REQUEST";
export const SAVE_JOB_SUCCESS = "SAVE_JOB_SUCCESS";
export const SAVE_JOB_FAIL = "SAVE_JOB_FAIL";

// Remove Job Actions
export const REMOVE_JOB_REQUEST = "REMOVE_JOB_REQUEST";
export const REMOVE_JOB_SUCCESS = "REMOVE_JOB_SUCCESS";
export const REMOVE_JOB_FAIL = "REMOVE_JOB_FAIL";

// Unnanu Jobs
export const FETCH_UNNANU_JOBS_REQUEST = "FETCH_UNNANU_JOBS_REQUEST";
export const FETCH_UNNANU_JOBS_SUCCESS = "FETCH_UNNANU_JOBS_SUCCESS";
export const FETCH_UNNANU_JOBS_FAIL = "FETCH_UNNANU_JOBS_FAIL";

export const WITHDRAW_UNNANU_JOB_REQUEST = "WITHDRAW_UNNANU_JOB_REQUEST";
export const WITHDRAW_UNNANU_JOB_SUCCESS = "WITHDRAW_UNNANU_JOB_SUCCESS";
export const WITHDRAW_UNNANU_JOB_FAIL = "WITHDRAW_UNNANU_JOB_FAIL";

// X Jobs
export const FETCH_X_JOBS_REQUEST = "FETCH_X_JOBS_REQUEST";
export const FETCH_X_JOBS_SUCCESS = "FETCH_X_JOBS_SUCCESS";
export const FETCH_X_JOBS_FAIL = "FETCH_X_JOBS_FAIL";

export const SAVE_X_JOB_REQUEST = "SAVE_X_JOB_REQUEST";
export const SAVE_X_JOB_SUCCESS = "SAVE_X_JOB_SUCCESS";
export const SAVE_X_JOB_FAIL = "SAVE_X_JOB_FAIL";

export const IN_PROCESS_X_JOB_REQUEST = "IN_PROCESS_X_JOB_REQUEST";
export const IN_PROCESS_X_JOB_SUCCESS = "IN_PROCESS_X_JOB_SUCCESS";
export const IN_PROCESS_X_JOB_FAIL = "IN_PROCESS_X_JOB_FAIL";

export const REMOVE_IN_PROCESS_X_JOB_REQUEST =
  "REMOVE_IN_PROCESS_X_JOB_REQUEST";
export const REMOVE_IN_PROCESS_X_JOB_SUCCESS =
  "REMOVE_IN_PROCESS_X_JOB_SUCCESS";
export const REMOVE_IN_PROCESS_X_JOB_FAIL = "REMOVE_IN_PROCESS_X_JOB_FAIL";

export const APPLY_X_JOB_REQUEST = "APPLY_X_JOB_REQUEST";
export const APPLY_X_JOB_SUCCESS = "APPLY_X_JOB_SUCCESS";
export const APPLY_X_JOB_FAIL = "APPLY_X_JOB_FAIL";

export const REMOVE_SAVE_X_JOB_REQUEST = "REMOVE_SAVE_X_JOB_REQUEST";
export const REMOVE_SAVE_X_JOB_SUCCESS = "REMOVE_SAVE_X_JOB_SUCCESS";
export const REMOVE_SAVE_X_JOB_FAIL = "REMOVE_SAVE_X_JOB_FAIL";

export const WITHDRAW_X_JOB_REQUEST = "WITHDRAW_X_JOB_REQUEST";
export const WITHDRAW_X_JOB_SUCCESS = "WITHDRAW_X_JOB_SUCCESS";
export const WITHDRAW_X_JOB_FAIL = "WITHDRAW_X_JOB_FAIL";

// Google Jobs
export const FETCH_GOOGLE_JOBS_REQUEST = "FETCH_GOOGLE_JOBS_REQUEST";
export const FETCH_GOOGLE_JOBS_SUCCESS = "FETCH_GOOGLE_JOBS_SUCCESS";
export const FETCH_GOOGLE_JOBS_FAIL = "FETCH_GOOGLE_JOBS_FAIL";

export const SAVE_GOOGLE_JOB_REQUEST = "SAVE_GOOGLE_JOB_REQUEST";
export const SAVE_GOOGLE_JOB_SUCCESS = "SAVE_GOOGLE_JOB_SUCCESS";
export const SAVE_GOOGLE_JOB_FAIL = "SAVE_GOOGLE_JOB_FAIL";

export const IN_PROCESS_GOOGLE_JOB_REQUEST = "IN_PROCESS_GOOGLE_JOB_REQUEST";
export const IN_PROCESS_GOOGLE_JOB_SUCCESS = "IN_PROCESS_GOOGLE_JOB_SUCCESS";
export const IN_PROCESS_GOOGLE_JOB_FAIL = "IN_PROCESS_GOOGLE_JOB_FAIL";

export const REMOVE_IN_PROCESS_GOOGLE_JOB_REQUEST =
  "REMOVE_IN_PROCESS_GOOGLE_JOB_REQUEST";
export const REMOVE_IN_PROCESS_GOOGLE_JOB_SUCCESS =
  "REMOVE_IN_PROCESS_GOOGLE_JOB_SUCCESS";
export const REMOVE_IN_PROCESS_GOOGLE_JOB_FAIL =
  "REMOVE_IN_PROCESS_GOOGLE_JOB_FAIL";

export const APPLY_GOOGLE_JOB_REQUEST = "APPLY_GOOGLE_JOB_REQUEST";
export const APPLY_GOOGLE_JOB_SUCCESS = "APPLY_GOOGLE_JOB_SUCCESS";
export const APPLY_GOOGLE_JOB_FAIL = "APPLY_GOOGLE_JOB_FAIL";

export const REMOVE_SAVE_GOOGLE_JOB_REQUEST = "REMOVE_SAVE_GOOGLE_JOB_REQUEST";
export const REMOVE_SAVE_GOOGLE_JOB_SUCCESS = "REMOVE_SAVE_GOOGLE_JOB_SUCCESS";
export const REMOVE_SAVE_GOOGLE_JOB_FAIL = "REMOVE_SAVE_GOOGLE_JOB_FAIL";

export const WITHDRAW_GOOGLE_JOB_REQUEST = "WITHDRAW_GOOGLE_JOB_REQUEST";
export const WITHDRAW_GOOGLE_JOB_SUCCESS = "WITHDRAW_GOOGLE_JOB_SUCCESS";
export const WITHDRAW_GOOGLE_JOB_FAIL = "WITHDRAW_GOOGLE_JOB_FAIL";

// Indeed Jobs
export const FETCH_INDEED_JOBS_REQUEST = "FETCH_INDEED_JOBS_REQUEST";
export const FETCH_INDEED_JOBS_SUCCESS = "FETCH_INDEED_JOBS_SUCCESS";
export const FETCH_INDEED_JOBS_FAIL = "FETCH_INDEED_JOBS_FAIL";

export const SAVE_INDEED_JOB_REQUEST = "SAVE_INDEED_JOB_REQUEST";
export const SAVE_INDEED_JOB_SUCCESS = "SAVE_INDEED_JOB_SUCCESS";
export const SAVE_INDEED_JOB_FAIL = "SAVE_INDEED_JOB_FAIL";

export const IN_PROCESS_INDEED_JOB_REQUEST = "IN_PROCESS_INDEED_JOB_REQUEST";
export const IN_PROCESS_INDEED_JOB_SUCCESS = "IN_PROCESS_INDEED_JOB_SUCCESS";
export const IN_PROCESS_INDEED_JOB_FAIL = "IN_PROCESS_INDEED_JOB_FAIL";

export const REMOVE_IN_PROCESS_INDEED_JOB_REQUEST =
  "REMOVE_IN_PROCESS_INDEED_JOB_REQUEST";
export const REMOVE_IN_PROCESS_INDEED_JOB_SUCCESS =
  "REMOVE_IN_PROCESS_INDEED_JOB_SUCCESS";
export const REMOVE_IN_PROCESS_INDEED_JOB_FAIL =
  "REMOVE_IN_PROCESS_INDEED_JOB_FAIL";

export const APPLY_INDEED_JOB_REQUEST = "APPLY_INDEED_JOB_REQUEST";
export const APPLY_INDEED_JOB_SUCCESS = "APPLY_INDEED_JOB_SUCCESS";
export const APPLY_INDEED_JOB_FAIL = "APPLY_INDEED_JOB_FAIL";

export const REMOVE_SAVE_INDEED_JOB_REQUEST = "REMOVE_SAVE_INDEED_JOB_REQUEST";
export const REMOVE_SAVE_INDEED_JOB_SUCCESS = "REMOVE_SAVE_INDEED_JOB_SUCCESS";
export const REMOVE_SAVE_INDEED_JOB_FAIL = "REMOVE_SAVE_INDEED_JOB_FAIL";

export const WITHDRAW_INDEED_JOB_REQUEST = "WITHDRAW_INDEED_JOB_REQUEST";
export const WITHDRAW_INDEED_JOB_SUCCESS = "WITHDRAW_INDEED_JOB_SUCCESS";
export const WITHDRAW_INDEED_JOB_FAIL = "WITHDRAW_INDEED_JOB_FAIL";

// Linkedin Jobs
export const FETCH_LINKEDIN_JOBS_REQUEST = "FETCH_LINKEDIN_JOBS_REQUEST";
export const FETCH_LINKEDIN_JOBS_SUCCESS = "FETCH_LINKEDIN_JOBS_SUCCESS";
export const FETCH_LINKEDIN_JOBS_FAIL = "FETCH_LINKEDIN_JOBS_FAIL";

export const SAVE_LINKEDIN_JOB_REQUEST = "SAVE_LINKEDIN_JOB_REQUEST";
export const SAVE_LINKEDIN_JOB_SUCCESS = "SAVE_LINKEDIN_JOB_SUCCESS";
export const SAVE_LINKEDIN_JOB_FAIL = "SAVE_LINKEDIN_JOB_FAIL";

export const IN_PROCESS_LINKEDIN_JOB_REQUEST =
  "IN_PROCESS_LINKEDIN_JOB_REQUEST";
export const IN_PROCESS_LINKEDIN_JOB_SUCCESS =
  "IN_PROCESS_LINKEDIN_JOB_SUCCESS";
export const IN_PROCESS_LINKEDIN_JOB_FAIL = "IN_PROCESS_LINKEDIN_JOB_FAIL";

export const REMOVE_IN_PROCESS_LINKEDIN_JOB_REQUEST =
  "REMOVE_IN_PROCESS_LINKEDIN_JOB_REQUEST";
export const REMOVE_IN_PROCESS_LINKEDIN_JOB_SUCCESS =
  "REMOVE_IN_PROCESS_LINKEDIN_JOB_SUCCESS";
export const REMOVE_IN_PROCESS_LINKEDIN_JOB_FAIL =
  "REMOVE_IN_PROCESS_LINKEDIN_JOB_FAIL";

export const APPLY_LINKEDIN_JOB_REQUEST = "APPLY_LINKEDIN_JOB_REQUEST";
export const APPLY_LINKEDIN_JOB_SUCCESS = "APPLY_LINKEDIN_JOB_SUCCESS";
export const APPLY_LINKEDIN_JOB_FAIL = "APPLY_LINKEDIN_JOB_FAIL";

export const REMOVE_SAVE_LINKEDIN_JOB_REQUEST =
  "REMOVE_Save_LINKEDIN_JOB_REQUEST";
export const REMOVE_SAVE_LINKEDIN_JOB_SUCCESS =
  "REMOVE_SAVE_LINKEDIN_JOB_SUCCESS";
export const REMOVE_SAVE_LINKEDIN_JOB_FAIL = "REMOVE_SAVE_LINKEDIN_JOB_FAIL";

export const WITHDRAW_LINKEDIN_JOB_REQUEST = "WITHDRAW_LINKEDIN_JOB_REQUEST";
export const WITHDRAW_LINKEDIN_JOB_SUCCESS = "WITHDRAW_LINKEDIN_JOB_SUCCESS";
export const WITHDRAW_LINKEDIN_JOB_FAIL = "WITHDRAW_LINKEDIN_JOB_FAIL";

// Glassdoor Jobs
export const FETCH_GLASSDOOR_JOBS_REQUEST = "FETCH_GLASSDOOR_JOBS_REQUEST";
export const FETCH_GLASSDOOR_JOBS_SUCCESS = "FETCH_GLASSDOOR_JOBS_SUCCESS";
export const FETCH_GLASSDOOR_JOBS_FAIL = "FETCH_GLASSDOOR_JOBS_FAIL";

export const SAVE_GLASSDOOR_JOB_REQUEST = "SAVE_GLASSDOOR_JOB_REQUEST";
export const SAVE_GLASSDOOR_JOB_SUCCESS = "SAVE_GLASSDOOR_JOB_SUCCESS";
export const SAVE_GLASSDOOR_JOB_FAIL = "SAVE_GLASSDOOR_JOB_FAIL";

export const IN_PROCESS_GLASSDOOR_JOB_REQUEST =
  "IN_PROCESS_GLASSDOOR_JOB_REQUEST";
export const IN_PROCESS_GLASSDOOR_JOB_SUCCESS =
  "IN_PROCESS_GLASSDOOR_JOB_SUCCESS";
export const IN_PROCESS_GLASSDOOR_JOB_FAIL = "IN_PROCESS_GLASSDOOR_JOB_FAIL";

export const REMOVE_IN_PROCESS_GLASSDOOR_JOB_REQUEST =
  "REMOVE_IN_PROCESS_GLASSDOOR_JOB_REQUEST";
export const REMOVE_IN_PROCESS_GLASSDOOR_JOB_SUCCESS =
  "REMOVE_IN_PROCESS_GLASSDOOR_JOB_SUCCESS";
export const REMOVE_IN_PROCESS_GLASSDOOR_JOB_FAIL =
  "REMOVE_IN_PROCESS_GLASSDOOR_JOB_FAIL";

export const APPLY_GLASSDOOR_JOB_REQUEST = "APPLY_GLASSDOOR_JOB_REQUEST";
export const APPLY_GLASSDOOR_JOB_SUCCESS = "APPLY_GLASSDOOR_JOB_SUCCESS";
export const APPLY_GLASSDOOR_JOB_FAIL = "APPLY_GLASSDOOR_JOB_FAIL";

export const REMOVE_SAVE_GLASSDOOR_JOB_REQUEST =
  "REMOVE_SAVE_GLASSDOOR_JOB_REQUEST";
export const REMOVE_SAVE_GLASSDOOR_JOB_SUCCESS =
  "REMOVE_SAVE_GLASSDOOR_JOB_SUCCESS";
export const REMOVE_SAVE_GLASSDOOR_JOB_FAIL = "REMOVE_SAVE_GLASSDOOR_JOB_FAIL";

export const WITHDRAW_GLASSDOOR_JOB_REQUEST = "WITHDRAW_GLASSDOOR_JOB_REQUEST";
export const WITHDRAW_GLASSDOOR_JOB_SUCCESS = "WITHDRAW_GLASSDOOR_JOB_SUCCESS";
export const WITHDRAW_GLASSDOOR_JOB_FAIL = "WITHDRAW_GLASSDOOR_JOB_FAIL";

// Ziprecruiter Jobs
export const FETCH_ZIPRECRUITER_JOBS_REQUEST =
  "FETCH_ZIPRECRUITER_JOBS_REQUEST";
export const FETCH_ZIPRECRUITER_JOBS_SUCCESS =
  "FETCH_ZIPRECRUITER_JOBS_SUCCESS";
export const FETCH_ZIPRECRUITER_JOBS_FAIL = "FETCH_ZIPRECRUITER_JOBS_FAIL";

export const SAVE_ZIPRECRUITER_JOB_REQUEST = "SAVE_ZIPRECRUITER_JOB_REQUEST";
export const SAVE_ZIPRECRUITER_JOB_SUCCESS = "SAVE_ZIPRECRUITER_JOB_SUCCESS";
export const SAVE_ZIPRECRUITER_JOB_FAIL = "SAVE_ZIPRECRUITER_JOB_FAIL";

export const IN_PROCESS_ZIPRECRUITER_JOB_REQUEST =
  "IN_PROCESS_ZIPRECRUITER_JOB_REQUEST";
export const IN_PROCESS_ZIPRECRUITER_JOB_SUCCESS =
  "IN_PROCESS_ZIPRECRUITER_JOB_SUCCESS";
export const IN_PROCESS_ZIPRECRUITER_JOB_FAIL =
  "IN_PROCESS_ZIPRECRUITER_JOB_FAIL";

export const REMOVE_IN_PROCESS_ZIPRECRUITER_JOB_REQUEST =
  "REMOVE_IN_PROCESS_ZIPRECRUITER_JOB_REQUEST";
export const REMOVE_IN_PROCESS_ZIPRECRUITER_JOB_SUCCESS =
  "REMOVE_IN_PROCESS_ZIPRECRUITER_JOB_SUCCESS";
export const REMOVE_IN_PROCESS_ZIPRECRUITER_JOB_FAIL =
  "REMOVE_IN_PROCESS_ZIPRECRUITER_JOB_FAIL";

export const APPLY_ZIPRECRUITER_JOB_REQUEST = "APPLY_ZIPRECRUITER_JOB_REQUEST";
export const APPLY_ZIPRECRUITER_JOB_SUCCESS = "APPLY_ZIPRECRUITER_JOB_SUCCESS";
export const APPLY_ZIPRECRUITER_JOB_FAIL = "APPLY_ZIPRECRUITER_JOB_FAIL";

export const REMOVE_SAVE_ZIPRECRUITER_JOB_REQUEST =
  "REMOVE_SAVE_ZIPRECRUITER_JOB_REQUEST";
export const REMOVE_SAVE_ZIPRECRUITER_JOB_SUCCESS =
  "REMOVE_SAVE_ZIPRECRUITER_JOB_SUCCESS";
export const REMOVE_SAVE_ZIPRECRUITER_JOB_FAIL =
  "REMOVE_SAVE_ZIPRECRUITER_JOB_FAIL";

export const WITHDRAW_ZIPRECRUITER_JOB_REQUEST =
  "WITHDRAW_ZIPRECRUITER_JOB_REQUEST";
export const WITHDRAW_ZIPRECRUITER_JOB_SUCCESS =
  "WITHDRAW_ZIPRECRUITER_JOB_SUCCESS";
export const WITHDRAW_ZIPRECRUITER_JOB_FAIL = "WITHDRAW_ZIPRECRUITER_JOB_FAIL";

// Applied Jobs
export const FETCH_APPLIED_JOBS_REQUEST = "FETCH_APPLIED_JOBS_REQUEST";
export const FETCH_APPLIED_JOBS_SUCCESS = "FETCH_APPLIED_JOBS_SUCCESS";
export const FETCH_APPLIED_JOBS_FAIL = "FETCH_APPLIED_JOBS_FAIL";

export const FETCH_APPLIED_X_JOBS_REQUEST = "FETCH_APPLIED_X_JOBS_REQUEST";
export const FETCH_APPLIED_X_JOBS_SUCCESS = "FETCH_APPLIED_X_JOBS_SUCCESS";
export const FETCH_APPLIED_X_JOBS_FAIL = "FETCH_APPLIED_X_JOBS_FAIL";

export const FETCH_APPLIED_INDEED_JOBS_REQUEST =
  "FETCH_APPLIED_INDEED_JOBS_REQUEST";
export const FETCH_APPLIED_INDEED_JOBS_SUCCESS =
  "FETCH_APPLIED_INDEED_JOBS_SUCCESS";
export const FETCH_APPLIED_INDEED_JOBS_FAIL = "FETCH_APPLIED_INDEED_JOBS_FAIL";

export const FETCH_APPLIED_LINKEDIN_JOBS_REQUEST =
  "FETCH_APPLIED_LINKEDIN_JOBS_REQUEST";
export const FETCH_APPLIED_LINKEDIN_JOBS_SUCCESS =
  "FETCH_APPLIED_LINKEDIN_JOBS_SUCCESS";
export const FETCH_APPLIED_LINKEDIN_JOBS_FAIL =
  "FETCH_APPLIED_LINKEDIN_JOBS_FAIL";

export const FETCH_APPLIED_GOOGLE_JOBS_REQUEST =
  "FETCH_APPLIED_GOOGLE_JOBS_REQUEST";
export const FETCH_APPLIED_GOOGLE_JOBS_SUCCESS =
  "FETCH_APPLIED_GOOGLE_JOBS_SUCCESS";
export const FETCH_APPLIED_GOOGLE_JOBS_FAIL = "FETCH_APPLIED_GOOGLE_JOBS_FAIL";

export const FETCH_APPLIED_GLASSDOOR_JOBS_REQUEST =
  "FETCH_APPLIED_GLASSDOOR_JOBS_REQUEST";
export const FETCH_APPLIED_GLASSDOOR_JOBS_SUCCESS =
  "FETCH_APPLIED_GLASSDOOR_JOBS_SUCCESS";
export const FETCH_APPLIED_GLASSDOOR_JOBS_FAIL =
  "FETCH_APPLIED_GLASSDOOR_JOBS_FAIL";

export const FETCH_APPLIED_ZIPRECRUITER_JOBS_REQUEST =
  "FETCH_APPLIED_ZIPRECRUITER_JOBS_REQUEST";
export const FETCH_APPLIED_ZIPRECRUITER_JOBS_SUCCESS =
  "FETCH_APPLIED_ZIPRECRUITER_JOBS_SUCCESS";
export const FETCH_APPLIED_ZIPRECRUITER_JOBS_FAIL =
  "FETCH_APPLIED_ZIPRECRUITER_JOBS_FAIL";

export const DELETE_UNNANU_JOB_REQUEST = "DELETE_UNNANU_JOB_REQUEST";
export const DELETE_UNNANU_JOB_SUCCESS = "DELETE_UNNANU_JOB_SUCCESS";
export const DELETE_UNNANU_JOB_FAIL = "DELETE_UNNANU_JOB_FAIL";

export const DELETE_X_JOB_REQUEST = "DELETE_X_JOB_REQUEST";
export const DELETE_X_JOB_SUCCESS = "DELETE_X_JOB_SUCCESS";
export const DELETE_X_JOB_FAIL = "DELETE_X_JOB_FAIL";

export const DELETE_GOOGLE_JOB_REQUEST = "DELETE_GOOGLE_JOB_REQUEST";
export const DELETE_GOOGLE_JOB_SUCCESS = "DELETE_GOOGLE_JOB_SUCCESS";
export const DELETE_GOOGLE_JOB_FAIL = "DELETE_GOOGLE_JOB_FAIL";

export const DELETE_INDEED_JOB_REQUEST = "DELETE_INDEED_JOB_REQUEST";
export const DELETE_INDEED_JOB_SUCCESS = "DELETE_INDEED_JOB_SUCCESS";
export const DELETE_INDEED_JOB_FAIL = "DELETE_INDEED_JOB_FAIL";

export const DELETE_LINKEDIN_JOB_REQUEST = "DELETE_LINKEDIN_JOB_REQUEST";
export const DELETE_LINKEDIN_JOB_SUCCESS = "DELETE_LINKEDIN_JOB_SUCCESS";
export const DELETE_LINKEDIN_JOB_FAIL = "DELETE_LINKEDIN_JOB_FAIL";

export const DELETE_GLASSDOOR_JOB_REQUEST = "DELETE_GLASSDOOR_JOB_REQUEST";
export const DELETE_GLASSDOOR_JOB_SUCCESS = "DELETE_GLASSDOOR_JOB_SUCCESS";
export const DELETE_GLASSDOOR_JOB_FAIL = "DELETE_GLASSDOOR_JOB_FAIL";

export const DELETE_ZIPRECRUITER_JOB_REQUEST =
  "DELETE_ZIPRECRUITER_JOB_REQUEST";
export const DELETE_ZIPRECRUITER_JOB_SUCCESS =
  "DELETE_ZIPRECRUITER_JOB_SUCCESS";
export const DELETE_ZIPRECRUITER_JOB_FAIL = "DELETE_ZIPRECRUITER_JOB_FAIL";

export const FETCH_JOB_EXTRACT_ACTIVITY_REQUEST =
  "FETCH_JOB_EXTRACT_ACTIVITY_REQUEST";
export const FETCH_JOB_EXTRACT_ACTIVITY_SUCCESS =
  "FETCH_JOB_EXTRACT_ACTIVITY_SUCCESS";
export const FETCH_JOB_EXTRACT_ACTIVITY_FAIL =
  "FETCH_JOB_EXTRACT_ACTIVITY_FAIL";

export const FETCH_JOBS_HEADER_COUNT_REQUEST =
  "FETCH_JOBS_HEADER_COUNT_REQUEST";
export const FETCH_JOBS_HEADER_COUNT_SUCCESS =
  "FETCH_JOBS_HEADER_COUNT_SUCCESS";
export const FETCH_JOBS_HEADER_COUNT_FAIL = "FETCH_JOBS_HEADER_COUNT_FAIL";

// Action Types
export const FETCH_SAVED_X_JOBS_REQUEST = "FETCH_SAVED_X_JOBS_REQUEST";
export const FETCH_SAVED_X_JOBS_SUCCESS = "FETCH_SAVED_X_JOBS_SUCCESS";
export const FETCH_SAVED_X_JOBS_FAIL = "FETCH_SAVED_X_JOBS_FAIL";

export const FETCH_SAVED_GOOGLE_JOBS_REQUEST =
  "FETCH_SAVED_GOOGLE_JOBS_REQUEST";
export const FETCH_SAVED_GOOGLE_JOBS_SUCCESS =
  "FETCH_SAVED_GOOGLE_JOBS_SUCCESS";
export const FETCH_SAVED_GOOGLE_JOBS_FAIL = "FETCH_SAVED_GOOGLE_JOBS_FAIL";

// Indeed Jobs
export const FETCH_SAVED_INDEED_JOBS_REQUEST =
  "FETCH_SAVED_INDEED_JOBS_REQUEST";
export const FETCH_SAVED_INDEED_JOBS_SUCCESS =
  "FETCH_SAVED_INDEED_JOBS_SUCCESS";
export const FETCH_SAVED_INDEED_JOBS_FAIL = "FETCH_SAVED_INDEED_JOBS_FAIL";

// Linkedin Jobs
export const FETCH_SAVED_LINKEDIN_JOBS_REQUEST =
  "FETCH_SAVED_LINKEDIN_JOBS_REQUEST";
export const FETCH_SAVED_LINKEDIN_JOBS_SUCCESS =
  "FETCH_SAVED_LINKEDIN_JOBS_SUCCESS";
export const FETCH_SAVED_LINKEDIN_JOBS_FAIL = "FETCH_SAVED_LINKEDIN_JOBS_FAIL";

// Glassdoor Jobs
export const FETCH_SAVED_GLASSDOOR_JOBS_REQUEST =
  "FETCH_SAVED_GLASSDOOR_JOBS_REQUEST";
export const FETCH_SAVED_GLASSDOOR_JOBS_SUCCESS =
  "FETCH_SAVED_GLASSDOOR_JOBS_SUCCESS";
export const FETCH_SAVED_GLASSDOOR_JOBS_FAIL =
  "FETCH_SAVED_GLASSDOOR_JOBS_FAIL";

// Ziprecruiter Jobs
export const FETCH_SAVED_ZIPRECRUITER_JOBS_REQUEST =
  "FETCH_SAVED_ZIPRECRUITER_JOBS_REQUEST";
export const FETCH_SAVED_ZIPRECRUITER_JOBS_SUCCESS =
  "FETCH_SAVED_ZIPRECRUITER_JOBS_SUCCESS";
export const FETCH_SAVED_ZIPRECRUITER_JOBS_FAIL =
  "FETCH_SAVED_ZIPRECRUITER_JOBS_FAIL";
// ... add remaining action types

// Add similar types for other job boards...

export function fetchLocation(location) {
  return { type: FETCH_LOCATION_SUCCEEDED, payload: location };
}

export function fetchLocationRequest(location) {
  return { type: FETCH_LOCATION, payload: location };
}
export function fetchLocationFailed(error) {
  return { type: FETCH_LOCATION_FAILED, payload: error };
}

export function showOrHidePopup(data) {
  return { type: POPUP_SHOW_HIDE, payload: data };
}

export function storeToken(token) {
  return { type: STORE_TOKEN, payload: token };
}

export function showOrHideMobileSearch(data) {
  return { type: MOBILE_SEARCH_SHOW, payload: data };
}

export function storeMobileSearchData(data) {
  return { type: MOBILE_SEARCH_DATA, payload: data };
}

export const setActiveJobName = (jobName) => ({
  type: SET_ACTIVE_JOB_NAME,
  payload: jobName,
});

export function fetchUserProfile(token) {
  return { type: FETCH_USER_PROFILE_REQUEST, payload: token };
}

export function signOut(data) {
  return { type: SIGN_OUT, payload: data };
}

export function signOutSuccess(data) {
  return { type: SIGN_OUT_SUCCESS, payload: data };
}
export function signOutFail(error) {
  return { type: SIGN_OUT_FAIL, payload: error };
}

export function fetchPopularJobs(location) {
  return { type: FETCH_POPULAR_JOBS_REQUEST, payload: location };
}

export function fetchNotifications(token) {
  return { type: FETCH_NOTIFICATIONS_REQUEST, payload: token };
}

export function fetchNotificationsSuccess(data) {
  return { type: FETCH_NOTIFICATIONS_SUCCESS, payload: data };
}
export function fetchNotificationsFail(error) {
  return { type: FETCH_NOTIFICATIONS_FAIL, payload: error };
}

export function fetchSavedJobs(token, page) {
  return {
    type: FETCH_SAVED_JOBS_REQUEST,
    payload: { token, page },
  };
}
export function fetchSavedJobsList(token) {
  return { type: FETCH_SAVED_JOBS_LIST_REQUEST, payload: token };
}

export function saveJob(token, jobId, job) {
  return {
    type: SAVE_JOB_REQUEST,
    payload: { token, jobId, job },
  };
}

export function removeJob(token, jobId) {
  return { type: REMOVE_JOB_REQUEST, payload: { token, jobId } };
}

export function fetchUnnanuJobs(token, page = 0) {
  return {
    type: FETCH_UNNANU_JOBS_REQUEST,
    payload: { token, page },
  };
}

export function fetchGoogleJobs(token, page, jobCount) {
  return { type: FETCH_GOOGLE_JOBS_REQUEST, payload: { token, page, jobCount } };
}

export function fetchXJobs(token, page, jobCount) {
  return { type: FETCH_X_JOBS_REQUEST, payload: { token, page, jobCount } };
}

export function fetchIndeedJobs(token, page, jobCount) {
  return { type: FETCH_INDEED_JOBS_REQUEST, payload: { token, page, jobCount } };
}

export function fetchLinkedinJobs(token, page, jobCount) {
  return { type: FETCH_LINKEDIN_JOBS_REQUEST, payload: { token, page, jobCount } };
}

export function fetchGlassdoorJobs(token, page, jobCount) {
  return { type: FETCH_GLASSDOOR_JOBS_REQUEST, payload: { token, page, jobCount } };
}

export function fetchZiprecruiterJobs(token, page, jobCount) {
  return { type: FETCH_ZIPRECRUITER_JOBS_REQUEST, payload: { token, page, jobCount } };
}

export function withdrawUnnanuJob(token, jobId) {
  return { type: WITHDRAW_UNNANU_JOB_REQUEST, payload: { token, jobId } };
}

export function saveGoogleJob(token, jobId, job) {
  return { type: SAVE_GOOGLE_JOB_REQUEST, payload: { token, jobId, job } };
}

export function inProcessGoogleJob(token, jobId, inProgress) {
  return {
    type: IN_PROCESS_GOOGLE_JOB_REQUEST,
    payload: { token, jobId, inProgress },
  };
}

export function applyGoogleJob(token, jobId, job) {
  return { type: APPLY_GOOGLE_JOB_REQUEST, payload: { token, jobId, job } };
}

export function saveXJob(token, jobId, job) {
  return { type: SAVE_X_JOB_REQUEST, payload: { token, jobId, job } };
}

export function inProcessXJob(token, jobId, inProgress) {
  return {
    type: IN_PROCESS_X_JOB_REQUEST,
    payload: { token, jobId, inProgress },
  };
}

export function applyXJob(token, jobId, job) {
  return { type: APPLY_X_JOB_REQUEST, payload: { token, jobId, job } };
}

export function removeSaveGoogleJob(token, jobId, job) {
  return {
    type: REMOVE_SAVE_GOOGLE_JOB_REQUEST,
    payload: { token, jobId, job },
  };
}
export function removeSaveXJob(token, jobId, job) {
  return { type: REMOVE_SAVE_X_JOB_REQUEST, payload: { token, jobId, job } };
}

export function withdrawGoogleJob(token, jobId, job) {
  return { type: WITHDRAW_GOOGLE_JOB_REQUEST, payload: { token, jobId } };
}

export function withdrawXJob(token, jobId) {
  return { type: WITHDRAW_X_JOB_REQUEST, payload: { token, jobId } };
}

// Add action creators for new job sources
export const saveIndeedJob = (token, jobId, job) => ({
  type: SAVE_INDEED_JOB_REQUEST,
  payload: { token, jobId, job },
});

export const inProcessIndeedJob = (token, jobId, inProgress) => ({
  type: IN_PROCESS_INDEED_JOB_REQUEST,
  payload: { token, jobId, inProgress },
});

export const applyIndeedJob = (token, jobId, job) => ({
  type: APPLY_INDEED_JOB_REQUEST,
  payload: { token, jobId, job },
});

export const removeSaveIndeedJob = (token, jobId, job) => ({
  type: REMOVE_SAVE_INDEED_JOB_REQUEST,
  payload: { token, jobId, job },
});

export const withdrawIndeedJob = (token, jobId) => ({
  type: WITHDRAW_INDEED_JOB_REQUEST,
  payload: { token, jobId },
});

export function saveLinkedinJob(token, jobId, job) {
  return { type: SAVE_LINKEDIN_JOB_REQUEST, payload: { token, jobId, job } };
}

export function inProcessLinkedinJob(token, jobId, inProgress) {
  return {
    type: IN_PROCESS_LINKEDIN_JOB_REQUEST,
    payload: { token, jobId, inProgress },
  };
}

export function applyLinkedinJob(token, jobId, job) {
  return { type: APPLY_LINKEDIN_JOB_REQUEST, payload: { token, jobId, job } };
}
export function removeSaveLinkedinJob(token, jobId, job) {
  return {
    type: REMOVE_SAVE_LINKEDIN_JOB_REQUEST,
    payload: { token, jobId, job },
  };
}

export function withdrawLinkedinJob(token, jobId) {
  return { type: WITHDRAW_LINKEDIN_JOB_REQUEST, payload: { token, jobId } };
}

export function saveGlassdoorJob(token, jobId, job) {
  return { type: SAVE_GLASSDOOR_JOB_REQUEST, payload: { token, jobId, job } };
}

export function inProcessGlassdoorJob(token, jobId, inProgress) {
  return {
    type: IN_PROCESS_GLASSDOOR_JOB_REQUEST,
    payload: { token, jobId, inProgress },
  };
}

export function applyGlassdoorJob(token, jobId, job) {
  return { type: APPLY_GLASSDOOR_JOB_REQUEST, payload: { token, jobId, job } };
}

export function removeSaveGlassdoorJob(token, jobId, job) {
  return {
    type: REMOVE_SAVE_GLASSDOOR_JOB_REQUEST,
    payload: { token, jobId, job },
  };
}

export function withdrawGlassdoorJob(token, jobId) {
  return { type: WITHDRAW_GLASSDOOR_JOB_REQUEST, payload: { token, jobId } };
}

export function saveZiprecruiterJob(token, jobId, job) {
  return {
    type: SAVE_ZIPRECRUITER_JOB_REQUEST,
    payload: { token, jobId, job },
  };
}

export function inProcessZiprecruiterJob(token, jobId, inProgress) {
  return {
    type: IN_PROCESS_ZIPRECRUITER_JOB_REQUEST,
    payload: { token, jobId, inProgress },
  };
}

export function applyZiprecruiterJob(token, jobId, job) {
  return {
    type: APPLY_ZIPRECRUITER_JOB_REQUEST,
    payload: { token, jobId, job },
  };
}

export function removeSaveZiprecruiterJob(token, jobId, job) {
  return {
    type: REMOVE_SAVE_ZIPRECRUITER_JOB_REQUEST,
    payload: { token, jobId, job },
  };
}

export function withdrawZiprecruiterJob(token, jobId) {
  return {
    type: WITHDRAW_ZIPRECRUITER_JOB_REQUEST,
    payload: { token, jobId },
  };
}

export const deleteUnnanuJob = (token, jobId) => ({
  type: DELETE_UNNANU_JOB_REQUEST,
  payload: { token, jobId },
});

export const deleteXJob = (token, jobId) => ({
  type: DELETE_X_JOB_REQUEST,
  payload: { token, jobId },
});

export const deleteGoogleJob = (token, jobId) => ({
  type: DELETE_GOOGLE_JOB_REQUEST,
  payload: { token, jobId },
});

export const deleteIndeedJob = (token, jobId) => ({
  type: DELETE_INDEED_JOB_REQUEST,
  payload: { token, jobId },
});

export const deleteLinkedinJob = (token, jobId) => ({
  type: DELETE_LINKEDIN_JOB_REQUEST,
  payload: { token, jobId },
});

export const deleteGlassdoorJob = (token, jobId) => ({
  type: DELETE_GLASSDOOR_JOB_REQUEST,
  payload: { token, jobId },
});

export const deleteZiprecruiterJob = (token, jobId) => ({
  type: DELETE_ZIPRECRUITER_JOB_REQUEST,
  payload: { token, jobId },
});

export const fetchJobExtractActivity = (token) => ({
  type: FETCH_JOB_EXTRACT_ACTIVITY_REQUEST,
  payload: token,
});

export const fetchJobsHeaderCount = (token) => ({
  type: FETCH_JOBS_HEADER_COUNT_REQUEST,
  payload: token,
});

// Action Creators
export const fetchSavedXJobs = (token, page, jobCount) => ({
  type: FETCH_SAVED_X_JOBS_REQUEST,
  payload: { token, page, jobCount },
});

export const fetchSavedGoogleJobs = (token, page, jobCount) => ({
  type: FETCH_SAVED_GOOGLE_JOBS_REQUEST,
  payload: { token, page, jobCount },
});

// Action creators
export const fetchSavedIndeedJobs = (token, page, jobCount) => ({
  type: FETCH_SAVED_INDEED_JOBS_REQUEST,
  payload: { token, page, jobCount },
});

export const fetchSavedLinkedinJobs = (token, page, jobCount) => ({
  type: FETCH_SAVED_LINKEDIN_JOBS_REQUEST,
  payload: { token, page, jobCount },
});

export const fetchSavedGlassdoorJobs = (token, page, jobCount) => ({
  type: FETCH_SAVED_GLASSDOOR_JOBS_REQUEST,
  payload: { token, page, jobCount },
});

export const fetchSavedZiprecruiterJobs = (token, page, jobCount) => ({
  type: FETCH_SAVED_ZIPRECRUITER_JOBS_REQUEST,
  payload: { token, page, jobCount },
});

export function fetchAppliedJobs(token, page, jobCount) {
  return { type: FETCH_APPLIED_JOBS_REQUEST, payload: { token, page, jobCount }};
}

export function fetchAppliedXJobs(token, page, jobCount) {
  return { type: FETCH_APPLIED_X_JOBS_REQUEST, payload: { token, page, jobCount } };
}

export function fetchAppliedIndeedJobs(token, page, jobCount) {
  return { type: FETCH_APPLIED_INDEED_JOBS_REQUEST, payload: { token, page, jobCount } };
}

export function fetchAppliedLinkedinJobs(token, page, jobCount) {
  return {
    type: FETCH_APPLIED_LINKEDIN_JOBS_REQUEST,
    payload: { token, page, jobCount },
  };
}

export function fetchAppliedGoogleJobs(token, page, jobCount) {
  return { type: FETCH_APPLIED_GOOGLE_JOBS_REQUEST, payload: { token, page, jobCount } };
}

export function fetchAppliedGlassdoorJobs(token, page, jobCount) {
  return {
    type: FETCH_APPLIED_GLASSDOOR_JOBS_REQUEST,
    payload: { token, page, jobCount },
  };
}

export function fetchAppliedZiprecruiterJobs(token, page, jobCount) {
  return {
    type: FETCH_APPLIED_ZIPRECRUITER_JOBS_REQUEST,
    payload: { token, page, jobCount },
  };
}

// Add similar action creators for other job boards...

// Add loading states
export const SET_JOB_LOADING = "SET_JOB_LOADING";

// Action creators
export const setJobLoading = (jobType, isLoading) => ({
  type: SET_JOB_LOADING,
  payload: { jobType, isLoading },
});



// WEBPACK FOOTER //
// ./store/app/actions.js